export enum OCPIRole {
  CPO = 'CPO',
  EMSP = 'EMSP',
}
